/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Injectable } from '@angular/core';
import { environment } from '@env';
import * as iuguFields from './defineIuguFields.json';
import { IScope } from './InterfaceIuguAfya'

interface ITokenCartao {
  firstName: string;
  surname: string;
  cardNumber: string
  expiredMonth: string
  expiredYear: string
  verifyingDigit: string
}

interface IResponse {
  success: boolean;
  data?: any;
}

@Injectable({
  providedIn: 'root'
})

export class IugoService {
  private scope: IScope = {
    dadosPagamento: {}
  };
  private data: any;
  private Iugu;
  private link_domain_payment = '';

  constructor() { }

  async execute(requestData: any): Promise<IResponse> {
    await this.checkScriptIuguLoaded();

    if (!this.Iugu) {
      return {
        success: false,
        data: {
          message: 'Erro ao realizar pagamento'
        }
      }
    }

    this.setScopeValuesByFormdata(requestData.data);
    this.setRefereceIuguPayment();

    if (!this.scope.contaIugu || this.scope.dadosPagamento.referenciaContaIugu === undefined) {
      return {
        success: false,
        data: {
          message: 'Erro ao realizar pagamento'
        }
      }
    }

    this.Iugu.setAccountID(this.scope.contaIugu);
    this.setTestModeIugu();
    this.setLinkDomainPayment();

    const returnData: IResponse = this.scope.dadosPagamento.formaPagamento == '1' ? await this.payBillet() : await this.payCreditCard();

    return returnData;
  }

  private getIuguAccount() {
    const referenciaConta = this.scope.dadosPagamento.referenciaContaIugu;
    const nameEnvironment = `IUGU_ACCOUNT_${referenciaConta}`;
    return environment[nameEnvironment];
  }

  private setTestModeIugu() {
    this.scope.ambienteTesteIugu === "1" ? this.Iugu.setTestMode(true) : this.Iugu.setTestMode(false);
  }

  private setLinkDomainPayment() {
    this.link_domain_payment = this.scope.ambienteTesteAfya === "1" ? environment.API_AFYA_IUGU_HML : environment.API_AFYA_IUGU;
  }

  private async payBillet(): Promise<IResponse> {
    this.setDataRequest(this.scope.dadosPagamento.formaPagamento);

    const pay = await this.pay();

    if (!pay.success) {
      return {
        success: false,
        data: {
          message: 'Tivemos um problema ao realizar o pagamento'
        }
      }
    }

    const report = {
      url: pay.data.url,
      report_view_id: 2
    }

    return {
      success: true,
      data: {
        report
      }
    };
  }

  private async payCreditCard(): Promise<IResponse> {
    if (!this.validateCreditCardNumber(this.scope.dadosPagamento.numeroCartao)) {
      return ({
        success: false,
        data: {
          message: 'Número cartão inválido'
        }
      })
    }

    this.scope.dadosPagamento.cartaoCredInvalido = false;

    const token = await this.criarTokenCartao();

    if (token.success) {
      this.scope.dadosPagamento.tokenCartao = token.data;
      this.setDataRequest(this.scope.dadosPagamento.formaPagamento);

      const pay = await this.pay()

      if (!pay.success) {
        return {
          success: false,
          data: {
            message: 'Tivemos um problema ao realizar o pagamento',
            errors: pay.data.message
          }
        }
      }

      return {
        success: true,
        data: pay.data
      }
    }

    return {
      success: false,
      data: {
        message: 'Tivemos um problema ao realizar o pagamento'
      }
    }
  }

  private setScopeValuesByFormdata(fields: Array<any> = []) {
    this.scope.valorInscricao = this.formatValueToPay(fields.find(field => field.key == iuguFields.valorInscricao)?.value);
    this.scope.dadosPagamento.titular = fields.find(field => field.key == iuguFields.titular)?.value;
    this.scope.dadosPagamento.emailTitular = fields.find(field => field.key == iuguFields.emailTitular)?.value;
    this.scope.dadosPagamento.telefoneTitular = fields.find(field => field.key == iuguFields.telefoneTitular)?.value;
    this.scope.dadosPagamento.cpfTitular = fields.find(field => field.key == iuguFields.cpfTitular)?.value;
    this.scope.dadosPagamento.cepTitular = fields.find(field => field.key == iuguFields.cepTitular)?.value;
    this.scope.dadosPagamento.numeroTitular = fields.find(field => field.key == iuguFields.numeroTitular)?.value;
    this.scope.dadosPagamento.ruaTitular = fields.find(field => field.key == iuguFields.ruaTitular)?.value;
    this.scope.dadosPagamento.bairroTitular = fields.find(field => field.key == iuguFields.bairroTitular)?.value;
    this.scope.dadosPagamento.idCidade = fields.find(field => field.key == iuguFields.idCidade)?.value;
    this.scope.dadosPagamento.cidadeTitular = fields.find(field => field.key == iuguFields.cidadeTitular)?.value;
    this.scope.dadosPagamento.codColigada = fields.find(field => field.key == iuguFields.codColigada)?.value;
    this.scope.dadosPagamento.idpsTotvs = fields.find(field => field.key == iuguFields.idpsTotvs)?.value;
    this.scope.dadosPagamento.numeroInscricao = fields.find(field => field.key == iuguFields.numeroInscricao)?.value;
    this.scope.dadosPagamento.idLan = fields.find(field => field.key == iuguFields.idLan)?.value;
    this.scope.dadosPagamento.numeroCartao = fields.find(field => field.key == iuguFields.numeroCartao)?.value;
    this.scope.dadosPagamento.vencimentoAno = fields.find(field => field.key == iuguFields.vencimentoAno)?.value;
    this.scope.dadosPagamento.vencimentoMes = fields.find(field => field.key == iuguFields.vencimentoMes)?.value;
    this.scope.dadosPagamento.digitoCartao = fields.find(field => field.key == iuguFields.digitoCartao)?.value;
    this.scope.dadosPagamento.formaPagamento = fields.find(field => field.key == iuguFields.formaPagamento)?.value;
    this.scope.dadosPagamento.parcela = fields.find(field => field.key == iuguFields.parcela)?.value;
    this.scope.dadosPagamento.referenciaContaIugu = fields.find(field => field.key == iuguFields.referenciaContaIugu)?.value;
    this.scope.ambienteTesteIugu = fields.find(field => field.key == iuguFields.ambienteTesteIugu)?.value;
    this.scope.ambienteTesteAfya = fields.find(field => field.key == iuguFields.ambienteTesteAfya)?.value;
    this.scope.contaIugu = this.getIuguAccount();
  }

  private async pay(): Promise<IResponse> {
    const baseUrl = `${this.link_domain_payment}/Portal/transacaoIugu`;

    const queryStringData = Object.keys(this.data).map((key) => {
      const encodeParam = encodeURIComponent(key);
      const encodeValue = this.data[key] === undefined ? '' : encodeURIComponent(this.data[key]);
      return encodeParam + '=' + encodeValue;
    }).join('&');

    const fetchUrl = `${baseUrl}?${queryStringData}`;

    const response = await fetch(fetchUrl);
    const payData = await response.json();

    if (!payData?.success) {
      return {
        success: false,
        data: {
          message: 'Tivemos um problema ao realizar o pagamento',
          errors: payData.erro
        }
      }
    }

    return {
      success: true,
      data: payData.dadosTransacao
    };
  }

  private setRefereceIuguPayment() {
    const codColigada = this.scope.dadosPagamento.codColigada;
    const idpsTotvs = this.scope.dadosPagamento.idpsTotvs;
    const numeroInscricao = this.scope.dadosPagamento.numeroInscricao;

    this.scope.referenciaPagamentoIugu = `${codColigada}-${idpsTotvs}-${numeroInscricao}`;
    this.scope.dadosPagamento.referenciaPagamentoIugu = `${codColigada}-${idpsTotvs}-${numeroInscricao}`;
  }

  private async criarTokenCartao(): Promise<any> {
    const creditCardData: ITokenCartao = {
      cardNumber: this.scope.dadosPagamento.numeroCartao,
      expiredMonth: this.scope.dadosPagamento.vencimentoMes,
      expiredYear: this.scope.dadosPagamento.vencimentoAno,
      firstName: this.getFirstName(),
      surname: this.getSurname(),
      verifyingDigit: this.scope.dadosPagamento.digitoCartao
    };

    const creditCardIugu = this.Iugu.CreditCard(creditCardData.cardNumber, creditCardData.expiredMonth, creditCardData.expiredYear, creditCardData.firstName, creditCardData.surname, creditCardData.verifyingDigit);

    const tokenData: IResponse = {
      success: undefined,
      data: undefined
    };

    this.Iugu.createPaymentToken(creditCardIugu, (response) => {
      if (response?.errors) {
        tokenData.success = false;
        tokenData.data = {
          message: 'Erro ao realizar o pagamento',
          errors: response.errors
        };
      } else {
        tokenData.success = true;
        tokenData.data = response.id;
      }
    });

    await this.checkTokenData(tokenData);

    return tokenData;
  }

  private setDataRequest(paymentType) {
    this.data = {
      cpfTitular: this.scope.dadosPagamento.cpfTitular,
      formaPagamento: this.scope.dadosPagamento.formaPagamento,
      referenciaPagamentoIugu: this.scope.dadosPagamento.referenciaPagamentoIugu,
      titular: this.scope.dadosPagamento.titular,
      telefoneTitular: this.scope.dadosPagamento.telefoneTitular,
      emailTitular: this.scope.dadosPagamento.emailTitular,
      ruaTitular: this.scope.dadosPagamento.ruaTitular,
      numeroTitular: this.scope.dadosPagamento.numeroTitular,
      bairroTitular: this.scope.dadosPagamento.bairroTitular,
      idCidade: this.scope.dadosPagamento.idCidade,
      cidadeTitular: this.scope.dadosPagamento.cidadeTitular,
      cepTitular: this.scope.dadosPagamento.cepTitular,
      complementoTitulo: this.scope.dadosPagamento.complementoTitulo,
      referencia: this.scope.dadosPagamento.referenciaContaIugu ? 'UNIGRANRIO' : 'AFYA',
      modoTeste: this.scope.ambienteTesteIugu
    }

    if (paymentType == 2) {
      this.data.tokenCartao = this.scope.dadosPagamento.tokenCartao;
      this.data.parcela = this.scope.dadosPagamento.parcela;
    } else {
      delete this.data.tokenCartao;
      delete this.data.parcela;
    }
  }

  private async checkTokenData(data: IResponse, time = 0, awaitTime = 1000, limit = 60000): Promise<any> {
    await new Promise(r => setTimeout(r, awaitTime));

    if (data.success === undefined && time < limit) {
      await this.checkTokenData(data, time + awaitTime);
    }
  }

  private async checkScriptIuguLoaded(time = 0, awaitTime = 500, limit = 60000): Promise<any> {
    this.Iugu = (window as any).Iugu;

    if (!this.Iugu && time < limit) {
      await new Promise(r => setTimeout(r, awaitTime));
      await this.checkScriptIuguLoaded(time + awaitTime);
    }
  }

  private formatValueToPay(value = '') {
    const formatedValue = String(value).toUpperCase().replace(',', '.').replace('R', '').replace('$', '');
    return formatedValue;
  }

  private getFirstName(): string {
    const fullName = this.scope.dadosPagamento.titular.split(' ');
    const fistName = fullName[0];
    return fistName;
  }

  private getSurname(): string {
    const fullName = this.scope.dadosPagamento.titular.split(' ');
    delete fullName[0];
    const surname = fullName.join(' ');
    return surname;
  }

  private validateCreditCardNumber(creditCardNumber) {
    return this.Iugu.utils.validateCreditCardNumber(creditCardNumber);
  }

  public isPaymentButtonAfya({ button_id, related_component_id }: { button_id, related_component_id }): boolean {
    return iuguFields.button_id.includes(button_id) || iuguFields.related_component_id.includes(related_component_id);
  }

  public setScriptIntoHtml(): void {
    const elm = document.createElement('script');
    elm.type = 'text/javascript';
    elm.src = 'https://js.iugu.com/v2/';
    document.head.appendChild(elm);
  }

}
